<template>
    <div class="grey lighten-5 pa-5 rounded">
        <h3 class="t-heading-small pb-2">
            {{ $t('resources.planProposal.attributes.general_info') }}
        </h3>
        <span class="t-body font-weight-bold">{{
            $t('resources.planProposal.attributes.plan')
        }}</span>
        {{ planPackage.name }}<br />
        <span class="t-body font-weight-bold">{{
            $t('resources.planProposal.attributes.price')
        }}</span>
        {{ $t('resources.planProposal.attributes.starting_from') }}
        {{ $n(planPackage.price || 0, 'currency') }}

        <h3 class="t-heading-small pb-2 pt-8">
            {{ $t('resources.planProposal.attributes.summary') }}
        </h3>
        <div class="t-body">
            <module-list
                :modules="fixedModules"
                :title="$t('resources.planProposal.attributes.fixed_modules')"
                module-type="fixed"
            />

            <module-list
                :modules="addOnSelected"
                :title="
                    $t('resources.planProposal.attributes.optional_modules')
                "
                module-type="addon"
            />

            <v-row
                v-if="
                    !loyalty &&
                        renovation &&
                        configuration &&
                        configPriceValue > 0
                "
                class="py-1"
            >
                <v-col cols="4" class="py-0">
                    <strong class="font-weight-bold d-inline-block mb-2">{{
                        $t(
                            'resources.planProposal.attributes.implementation_fee',
                        )
                    }}</strong>
                </v-col>
                <v-col cols="8" class="py-0">
                    <span class="pl-2"
                        >{{ configPrice }}
                        {{
                            $t(
                                'resources.planProposal.attributes.charged_first_installment',
                            )
                        }}</span
                    ><br />
                </v-col>
            </v-row>
            <template v-if="discount > 0">
                <v-row class="py-1">
                    <v-col cols="4" class="py-0">
                        <strong class="font-weight-bold d-inline-block mb-2">{{
                            $t('resources.planProposal.attributes.total_price')
                        }}</strong>
                    </v-col>
                    <v-col cols="8" class="py-0">
                        <span class="pl-2"
                            >{{ totalPriceFormatted }}
                            {{
                                $t(
                                    'resources.planProposal.attributes.per_month',
                                )
                            }}</span
                        ><br />
                    </v-col>
                </v-row>
                <v-row class="py-1">
                    <v-col cols="4" class="py-0">
                        <strong class="font-weight-bold d-inline-block mb-2">{{
                            $t('resources.planProposal.attributes.discount')
                        }}</strong>
                    </v-col>
                    <v-col cols="8" class="py-0">
                        <span class="pl-2">{{ discountFormatted }}</span
                        ><br />
                    </v-col>
                </v-row>
            </template>
            <v-row class="py-1">
                <v-col cols="4" class="py-0">
                    <strong class="font-weight-bold d-inline-block mb-2">{{
                        $t('resources.planProposal.attributes.final_price')
                    }}</strong>
                </v-col>
                <v-col cols="8" class="py-0">
                    <strong class="pl-2"
                        >{{ finalPriceFormatted }}
                        {{
                            $t('resources.planProposal.attributes.per_month')
                        }}</strong
                    ><br />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import ModuleList from './ModuleList.vue'

export default {
    components: {
        ModuleList,
    },

    props: {
        planPackage: {
            type: Object,
            required: true,
        },
        totalPrice: {
            type: Number,
            required: true,
        },
        finalPrice: {
            type: Number,
            required: true,
        },
        discount: {
            type: Number,
            default: 0,
        },
        loyalty: {
            type: Boolean,
            default: false,
        },
        renovation: {
            type: Boolean,
            default: false,
        },
        configuration: {
            type: Boolean,
            default: false,
        },
        fixedModules: {
            type: Array,
            required: true,
        },
        addOnSelected: {
            type: Array,
            required: true,
        },
    },

    computed: {
        totalPriceFormatted() {
            return this.$i18n.n(this.totalPrice || 0, 'currency')
        },

        finalPriceFormatted() {
            return this.$i18n.n(this.finalPrice || 0, 'currency')
        },

        discountFormatted() {
            return this.$i18n.n(this.discount || 0, 'currency')
        },

        configPriceValue() {
            if (!this.planPackage || !this.planPackage.config_price) {
                return 0
            }
            return this.planPackage.config_price - this.finalPrice
        },

        configPrice() {
            return this.$i18n.n(this.configPriceValue, 'currency')
        },
    },
}
</script>

<style></style>
